export const isSignContractSubmitEnabled = signed => !!signed;



// WEBPACK FOOTER //
// ./src/common/modals/signContractModalState.js